<div *ngIf="data" class="page-container">
  <app-details-header
    [type]="typeHR | titlecase"
    [header]="data.unit | longNumber"
    [icon]="data.type | icon"
    (onEdit)="onEdit()"
    [useEdit]="canEdit"
  >
    <p>
      {{ 'user.lastOwnUpdate' | loc }}:
      <b>{{ data.unit.lastOwnerChange | lDate: 'dtShort' : ('label.never' | loc) }}</b>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section [headerKey]="typeHR">
      <app-users-unit-basic-data
        [parking]="parking"
        [storage]="storage"
        [shares]="data.displayShare"
        (showUnitCodes)="showUnitCodes = true"
      ></app-users-unit-basic-data>
    </app-details-section>

    <app-details-section headerKey="user.noteList">
      <app-notes [refId]="data.unit.id" [type]="NoteType.UNIT" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>

    <app-all-integration-codes [codes]="data.unit.unitCodes" [(show)]="showUnitCodes"></app-all-integration-codes>

    <app-details-section *ngIf="apartment" headerKey="commApartment.nominative">
      <app-users-rental-units-links [units]="[apartment]" [type]="RentalUnitType.APARTMENT"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section headerKey="label.bankAccount">
      {{ bankAccount | iban: ('label.empty' | loc) }}
    </app-details-section>

    <app-details-section headerKey="unit.residents">
      <app-users-residents-links [residents]="residents"> </app-users-residents-links>
    </app-details-section>

    <app-details-section *ngFor="let landlord of data.landlords; let last = last" [last]="last">
      <ng-container section-header>
        <span class="mat-caption">
          {{ 'label.attachments' | locUpper }}<br />
          {{ 'label.for' | locUpper }}: <b> {{ landlord | fullName }} </b>
        </span>
      </ng-container>
      <app-users-details-files [unitId]="data.unit.id" [residentId]="landlord.id" [canEdit]="canEdit"></app-users-details-files>
    </app-details-section>
  </div>
</div>
